import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faCircleNotch } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectLinkById } from '../../../../redux/slices/linkListSlice/linkListSlice';

const DeviceRaLinkStatusDisplay = ({ raLinkId }) => {
  const roomAlertLink = useSelector((state) => selectLinkById(state, raLinkId));
  if (!roomAlertLink) {
    return (<></>);
  }

  if (roomAlertLink.isConnected) {
    return (
      <>
        <FontAwesomeIcon icon={faCircle} className="text-success" title="Connected" />
        {' '}
        {roomAlertLink.name}
      </>
    );
  }
  return (
    <>
      <FontAwesomeIcon icon={faCircleNotch} className="text-muted" title="Not Connected" />
      {' '}
      {roomAlertLink.name}
    </>
  );
};

DeviceRaLinkStatusDisplay.propTypes = {
  raLinkId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.oneOf([null]),
  ]),
};

DeviceRaLinkStatusDisplay.defaultProps = {
  raLinkId: null,
};

export default DeviceRaLinkStatusDisplay;
